'use client';

import { useEffect } from 'react';
import { useMultistepForm } from '../../../form-controls/MultistepForm/hooks/useMultistepForm';
import type { BackHandlerProps } from '../types';

const BackHandler = ({ onBack }: BackHandlerProps) => {
  const { isFirstStep, goToPreviousStep } = useMultistepForm();

  useEffect(() => {
    const handleBack = () => {
      if (isFirstStep) {
        return false; // Signal that we want to close the sheet
      } else {
        goToPreviousStep();
        return true; // Signal that we handled the back navigation
      }
    };

    onBack(handleBack);
  }, [isFirstStep, goToPreviousStep, onBack]);

  return null;
};

export { BackHandler };
